export default {
  errorMsg:null,
  setupPasswordError:null,
  validateCode:null,
}